//
//  SDKDocsLinkRef.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
export var DocsLinkRefType;
(function (DocsLinkRefType) {
    DocsLinkRefType["documentationItem"] = "DocumentationItem";
    DocsLinkRefType["pageHeading"] = "PageHeading";
    DocsLinkRefType["url"] = "Url";
})(DocsLinkRefType || (DocsLinkRefType = {}));
export function docsLinkToUrl(link) {
    switch (link.type) {
        case DocsLinkRefType.documentationItem:
            return `@page:${link.documentationItemId}`;
        case DocsLinkRefType.pageHeading:
            return `@page:${link.documentationItemId}#${link.pageHeadingId}`;
        case DocsLinkRefType.url:
            return link.url;
        default:
            return undefined;
    }
}
export function docsLinkToLinkAttributes(link) {
    const url = docsLinkToUrl(link);
    if (!url) {
        return undefined;
    }
    return {
        href: url,
        target: link.openInNewTab ? "_blank" : "_self",
    };
}
export function linkAttributeToDocsLink(href, target) {
    if (!href) {
        return undefined;
    }
    const openInNewTab = target === "_blank";
    if (href.startsWith("@page:")) {
        // Parse link to documentation item
        if (href.includes("#")) {
            // Parse link to page heading
            const [pageId, headingId] = href.replace("@page:", "").split("#");
            return {
                type: DocsLinkRefType.pageHeading,
                documentationItemId: pageId,
                pageHeadingId: headingId,
                openInNewTab,
            };
        }
        return {
            type: DocsLinkRefType.documentationItem,
            documentationItemId: href.replace("@page:", ""),
            openInNewTab,
        };
    }
    return {
        type: DocsLinkRefType.url,
        url: href,
        openInNewTab,
    };
}
